import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";

// css
import "./Admin.css";
// components
import SideBar from "./Components/SideBar/SideBar";
import TopBar from "./Components/TopBar/TopBar";

// pages
import Home from "./Pages/Home/Home";
import Settings from "./Pages/Settings/Settings";
import UserList from "./Pages/UserList/UserList";
import User from "./Pages/User/User";
import CreateUser from "./Pages/CreateUser/CreateUser";

//Mock Test
import CreateMockTest from "./Pages/Mocktest/CreateMockTest/CreateMockTest";
import MockTestTable from "./Pages/Mocktest/MocktestTable/MockTestTable";

//Article
import ArticleTable from "./Pages/Article/ArticleTable/ArticleTable";
import CreateArticle from "./Pages/Article/CreateArticle/CreateArticle";

// Landmark
import CreateLandMark from "./Pages/LandMark/CreateLandMark/CreateLandMark";
import LandMarkTable from "./Pages/LandMark/LandMarkTable/LandMarkTable";

//LegalTerm
import CreateLegalTerm from "./Pages/LegalTerm/CreateLegalTerm/CreateLegalTerm";
import LegalTermTable from "./Pages/LegalTerm/LegalTermTable/LegalTermTable";

//Mcq
import CreateMcq from "./Pages/Mcq/CreateMcq/CreateMcq";
import McqTable from "./Pages/Mcq/McqTable/McqTable";

///Pyq
import Pyq from "./Pages/Pyq/PyqTable/PyqTable";
import CreatePyq from "./Pages/Pyq/CreatePyq/CreatePyq";

//Bare Act
import BareAct from "./Pages/BareAct/BareActTable/BareActTable";
import CreateBareAct from "./Pages/BareAct/CreateBareAct/CreateBareAct";

//Dictonary
import Dictionary from "./Pages/Dictionary/DictionaryTable/DictionaryTable";
import CreateDictionary from "./Pages/Dictionary/CreateDictinary/CreateDictionary";

// Syllabus
import Syllabus from "./Pages/Syllabus/SyllabusTable/SyllabusTable";
import CreateSyllabus from "./Pages/Syllabus/CreateSyllabus/CreateSyllabus";

//Legal Essay
import Legalessay from "./Pages/LegalEssay/LegalEssayTable/LegalEssayTable";
import CreateLegalEssay from "./Pages/LegalEssay/CreateLegalEssay/CreateLegalEssay";

//word Of Day
import Wordofday from "./Pages/WordOfDay/WordofdayTable";
import Carousel from "./Pages/Carousel/carousel";
import Carousellist from "./Pages/Carousel/carousellist";
import Addnotification from "./Pages/Addnotification/Addnotification";
import Notificationlist from "./Pages/Addnotification/notificationlist";
import Addsubject from "./Pages/Addsubject/Addsubject";

const Admin = () => {
  return (
    <div className="admin">
      <TopBar />
      <div className="admin__container">
        <SideBar />
        <Routes>
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/settings" element={<Settings />} />
          {/* <Route exact path="/user-list" element={<UserList />} /> */}
          <Route exact path="/user/:userId" element={<User />} />
          <Route exact path="/create-article" element={<CreateArticle />} />
          <Route exact path="/create-article/:id" element={<CreateArticle />} />
          <Route exact path="/article-table" element={<ArticleTable />} />
          <Route exact path="/landmark-table" element={<LandMarkTable />} />
          <Route exact path="/create-landmark/" element={<CreateLandMark />} />
          <Route exact path="/carousel" element={<Carousel />} />
          <Route exact path="/carousellist" element={<Carousellist />} />
          <Route exact path="/addnotification" element={<Addnotification />} />
          <Route
            exact
            path="/notificationlist"
            element={<Notificationlist />}
          />
          <Route exact path="/subject" element={<Addsubject />} />
          <Route
            exact
            path="/create-landmark/:id"
            element={<CreateLandMark />}
          />
          <Route exact path="/create-user" element={<CreateUser />} />
          <Route exact path="/legal-term-table" element={<LegalTermTable />} />
          <Route
            exact
            path="/create-legal-term"
            element={<CreateLegalTerm />}
          />
          <Route
            exact
            path="/create-legal-term/:id"
            element={<CreateLegalTerm />}
          />
          <Route exact path="/create-mcq" element={<CreateMcq />} />
          <Route exact path="/create-mcq/:id" element={<CreateMcq />} />
          <Route exact path="/mcq-table" element={<McqTable />} />

          <Route exact path="/create-mocktest" element={<CreateMockTest />} />
          <Route
            exact
            path="/create-mocktest/:id"
            element={<CreateMockTest />}
          />
          <Route exact path="/mocktest-table" element={<MockTestTable />} />

          <Route exact path="/create-pyq" element={<CreatePyq />} />
          <Route exact path="/create-pyq/:id" element={<CreatePyq />} />
          <Route exact path="/pyq-table" element={<Pyq />} />

          <Route exact path="/create-bareact" element={<CreateBareAct />} />
          <Route exact path="/create-bareact/:id" element={<CreateBareAct />} />
          <Route exact path="/bareAct-table" element={<BareAct />} />

          <Route
            exact
            path="/create-legalessay"
            element={<CreateLegalEssay />}
          />
          <Route
            exact
            path="/create-legalessay/:id"
            element={<CreateLegalEssay />}
          />
          <Route exact path="/legalessay-table" element={<Legalessay />} />

          <Route
            exact
            path="/create-dictionary"
            element={<CreateDictionary />}
          />
          <Route
            exact
            path="/create-dictionary/:id"
            element={<CreateDictionary />}
          />
          <Route exact path="/dictionary-table" element={<Dictionary />} />

          <Route exact path="/create-syllabus" element={<CreateSyllabus />} />
          <Route
            exact
            path="/create-syllabus/:id"
            element={<CreateSyllabus />}
          />
          <Route exact path="/syllabus-table" element={<Syllabus />} />

          <Route exact path="/word-of-day" element={<Wordofday />} />
        </Routes>
      </div>
    </div>
  );
};

export default Admin;
